import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import WhatsApp from './pages/WhatsApp';
import SendMessage from './pages/SendMessage';
import Messages from './pages/Messages';
import ApiKeys from './pages/ApiKeys';
import Logs from './pages/Logs';
import Config from './pages/Config';
import SystemHealth from './pages/SystemHealth';

function PrivateRoute({ children }) {
  const { admin, loading } = useAuth();
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#0f172a', flexDirection: 'column', gap: 16 }}>
        <div style={{ fontSize: 40 }}>💬</div>
        <div style={{ color: '#64748b', fontSize: 14 }}>Loading...</div>
      </div>
    );
  }
  return admin ? children : <Navigate to="/login" />;
}

function AppRoutes() {
  const { admin } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={admin ? <Navigate to="/" /> : <Login />} />
      <Route path="/register" element={admin ? <Navigate to="/" /> : <Register />} />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <SocketProvider>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/whatsapp" element={<WhatsApp />} />
                  <Route path="/send" element={<SendMessage />} />
                  <Route path="/messages" element={<Messages />} />
                  <Route path="/api-keys" element={<ApiKeys />} />
                  <Route path="/logs" element={<Logs />} />
                  <Route path="/config" element={<Config />} />
                  <Route path="/health" element={<SystemHealth />} />
                </Routes>
              </Layout>
            </SocketProvider>
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster
          position="top-right"
          toastOptions={{
            style: { background: '#1e293b', color: '#e2e8f0', border: '1px solid #334155', fontSize: 13 },
            success: { iconTheme: { primary: '#25d366', secondary: '#000' } },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}
